import { BaseImagenesApi } from '@/domain/entities/Api'
import addHours from 'date-fns/esm/addHours'
import parse from 'date-fns/esm/parseISO'
import esLocale from 'date-fns/esm/locale/es'
import format from 'date-fns-tz/esm/format'
import subHours from 'date-fns/esm/subHours'

const createArray = (baseImagenes: BaseImagenesApi, deltaHoras: number = 0, fecha_inicio: string = '') => {
  const delta = deltaHoras > 0 ? deltaHoras : baseImagenes.delta
  let returnDatestring = null
  let currentDatetime = fecha_inicio.length > 0 ? parse(fecha_inicio) : parse(baseImagenes.inicio)
  const options = { locale: esLocale }
  const arrayLength = baseImagenes.pasos
  return [...Array(arrayLength)].map((_, index): string => {
    if (index === 0) {
      returnDatestring = format(currentDatetime, 'dd LLL', options)
    } else {
      if (delta !== 1) {
        const previousDatetime = subHours(currentDatetime, delta)
        if (previousDatetime.getDay() !== currentDatetime.getDay()) {
          returnDatestring = format(currentDatetime, 'dd LLL', options)
        } else {
          returnDatestring = format(currentDatetime, 'HH:mm', options)
        }
        // This condition only applies if the delta is of 1 hour
      } else {
        const currentHour = format(currentDatetime, 'HH', options)
        if (currentHour === '00') {
          returnDatestring = format(currentDatetime, 'dd LLL', options)
        } else {
          returnDatestring = format(currentDatetime, 'HH:mm', options)
        }
      }
    }
    currentDatetime = addHours(currentDatetime, delta)
    return returnDatestring
  })
}

export {
  createArray
}
